export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12013.d728bb17.jpg";